<template>
  <div>
    <ClassListMobile v-model="onboardingMobileActive" />
    <ClassListDesktop v-model="onboardingDesktopActive" />
    <div v-if="!isLoading" :class="{ 'minimized': isMinimized === true }">
      <div v-if="!isFullAccess" class="classList --limited">
        <p class="classList__placeholder">Tu pojawią się informacje o&nbsp;<strong>nadchodzących zajęciach</strong></p>
      </div>
      <div v-else-if="!reversedLessons.length" class="classList --limited">
        <p class="classList__placeholder">Zapraszamy na zajęcia w nowym roku szkolnym!</p>
      </div>
      <div v-else class="classList">
        <div class="onboarding-button-wrapper">
          <button @click="startOnboarding" class="onboarding-button">
            <div class="flex items-center">
              <img id="classes-homework" src="@/assets/images/icons/i_pink.svg" />
              <p class="ml-2 text-pink-main text-lg font-medium">Zobacz jak to działa</p>
            </div>
          </button>
        </div>

        <div class="classList-controls">
          <div
            v-if="isMinimized"
            class="classList-controls__minimize"
            @click="isMinimized = !isMinimized"
          >
            <span>{{ $t('dashboard.class_list_show') }}</span>
            <img
              class="show icon-close-button"
              src="@/assets/images/icons/chevron-pink.svg"
            />
          </div>
          <div
            v-else
            class="classList-controls__minimize"
            @click="isMinimized = !isMinimized"
          >
            <span>{{ $t('dashboard.class_list_hide') }}</span>
            <img
              class="hide"
              src="@/assets/images/icons/chevron-pink.svg"
            />
          </div>
        </div>
        <button @click="startOnboarding" class="onboarding-button-mobile">
          <div class="flex items-center">
            <img id="classes-homework" src="@/assets/images/icons/i_pink.svg" />
            <p class="ml-2 text-pink-main text-lg font-medium">Zobacz jak to działa</p>
          </div>
        </button>
        <div class="flickity-container controls classList-list" :class="reversedLessons.length < 2 ? '--static' : null">
          <ClassList :lessons="reversedLessons" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  mapState, mapActions, mapMutations, mapGetters,
} from 'vuex';
import moment from 'moment';

import ClassListDesktop from '@/components/Popup/ClassListDesktop.vue';
import ClassListMobile from '@/components/Popup/ClassListMobile.vue';
import ClassList from './ClassList.vue';

export default {
  name: 'Classes',

  components: {
    ClassList,
    ClassListDesktop,
    ClassListMobile,
  },
  data() {
    return {
      windowWidth: 0,
      isMinimized: false,
      isLoading: true,
      onboardingMobileActive: false,
      onboardingDesktopActive: false,
    };
  },
  computed: {
    ...mapState('lessons', ['lessons', 'lesson']),
    ...mapState('students', ['student']),
    ...mapGetters('auth', ['isFullAccess']),

    reversedLessons() {
      return [...this.lessons].reverse();
    },
  },
  methods: {
    ...mapActions('lessons', [
      'getLessons',
    ]),
    ...mapMutations('layout', ['closeSidebar']),

    getWindowWidth() {
      this.windowWidth = window.innerWidth;
      Event.$emit('cancelTour');
      this.onboardingMobileActive = false;
      this.onboardingDesktopActive = false;
    },

    close() {
      this.closeSidebar();
    },

    async getData(studentId) {
      const date = moment().format('YYYY-MM-DD');
      try {
        await this.getLessons({
          studentId,
          payload: {
            dateFrom: date,
          },
        });
      } catch (e) {
        console.error(e);
      }
    },

    startOnboarding() {
      this.close();
      if (this.windowWidth < 992) {
        this.onboardingMobileActive = !this.onboardingMobileActive;
      } else {
        this.onboardingDesktopActive = !this.onboardingDesktopActive;
      }
    },
  },

  mounted() {
    this.windowWidth = window.innerWidth;
    window.addEventListener('resize', this.getWindowWidth);
  },

  async created() {
    this.isLoading = true;
    if (this.student?.id) {
      await this.getData(this.student.id);
    }
    if (this.windowWidth < 992 && this.isFullAccess) {
      this.isMinimized = true;
    }
    Event.$on('showClassList', () => {
      this.isMinimized = false;
    });
    Event.$on('hideClassList', () => {
      this.isMinimized = true;
    });
    this.isLoading = false;
    if (!this.lessons.length) this.isMinimized = false;
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowWidth);
  },
};
</script>

<style lang="scss" scoped>
.classList {
  @apply px-4 py-6 fixed bg-white overflow-hidden;
  z-index: 5;
  right: 0;
  bottom: 67px;
  left: 0;
  height: 244px;
  border-radius: 16px 16px 0 0;
  box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.12);
  transition: bottom 0.5s 0s cubic-bezier(0.1, 1.2, 0.3, 1),
    transform 0.5s 0s cubic-bezier(0.1, 1.2, 0.3, 1), opacity 0.3s;
  @media screen and (min-width: 992px) {
    @apply p-6;
    left: 312px;
    bottom: 0;
    margin-right: 40px;
    margin-left: 78px;
    height: 208px;
    animation: slideUp 0.5s ease-in-out both;
  }
  &.--limited {
    @apply flex items-center;
    line-height: 20px;
    height: 82px;
  }
  &__placeholder {
    @apply text-lg;
  }
  &-controls {
    @apply mb-4;
    @media screen and (min-width: 992px) {
      @apply absolute mb-0;
      top: 24px;
      left: 24px;
    }
    &__minimize {
      @apply cursor-pointer flex flex-1 justify-between items-center text-lg font-normal;
      width: 100%;
      height: 30px;
      @media screen and (min-width: 992px) {
        @apply justify-start;
        width: 230px;
      }
      img {
        @apply ml-2;
        width: 30px;
        height: 30px;
        transition: transform 0.5s cubic-bezier(0.1, 1.2, 0.3, 1);
        &.hide {
          transform: rotate3d(1, 0, 0, 180deg);
        }
      }
    }
  }
}

.minimized {
  .classList {
    bottom: -63px;
    @media screen and (min-width: 992px) {
      bottom: -130px;
    }
  }
}

.onboarding-button-wrapper {
  display: none;
  height: 30px;
  justify-content: flex-end;
  margin-bottom: 32px;
  @media screen and (min-width: 992px) {
    display: flex;
  }
}

.onboarding-button-mobile {
  height: 24px;
  margin-bottom: 32px;
  white-space: nowrap;
}

.onboarding-button {
  @apply hidden;
  white-space: nowrap;
  @media screen and (min-width: 992px) {
    @apply block;
  }
  &-mobile {
    @media screen and (min-width: 992px) {
      @apply hidden;
    }
  }
  img {
    width: 21px;
  }
}

.hide-class-list{
  .classList{
    display: none;
    @media screen and (max-width: 991px) {
      display: block;
    }
  }
}
</style>

<style lang="scss">
.classList {
  .flickity-viewport {
    height: 64px !important;
    margin-top: -6px;
    padding-top: 6px;
  }
}
</style>
